import React from 'react';
import PropTypes from 'prop-types';
import EducationQuickFact from '@components/molecules/education/quick-fact/educationQuickFact';
import { connect } from 'react-redux';
import Container from '../../../layout/container/container';
import StyledEducationQuickFacts from './educationQuickFacts.style';

function EducationQuickFacts({ educationMaterials, personCount, duration, educationLinks }) {
  return (
    <StyledEducationQuickFacts>
      <Container large>
        <div className="quick-facts__grid">
          {educationLinks && (
            <EducationQuickFact type="copy" title="Lernsettings" links={educationLinks} />
          )}
          {duration && <EducationQuickFact title="Dauer" duration={duration} />}
          {educationMaterials && <EducationQuickFact title="Material" copy={educationMaterials} />}
          {personCount && <EducationQuickFact title="Anzahl" personCount={personCount} />}
        </div>
      </Container>
    </StyledEducationQuickFacts>
  );
}

EducationQuickFacts.propTypes = {
  educationMaterials: PropTypes.string,
  personCount: PropTypes.number,
  duration: PropTypes.number,
  educationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
      educationExternalLink: PropTypes.string,
      educationExternalLinkTitle: PropTypes.string,
      educationLinks: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          src: PropTypes.string
        })
      )
    })
  )
};

const mapStateToProps = state => ({
  educationMaterials: state.app.pageData.educationMaterials,
  personCount: state.app.pageData.personCount,
  duration: state.app.pageData.duration,
  educationLinks: state.app.pageData.educationLinks
});

export default connect(mapStateToProps)(EducationQuickFacts);
